import React, { useEffect, useState } from 'react';
import { getPosts } from './services/wordpressService';
import { Link } from 'react-router-dom';

const PostsList = () => {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const data = await getPosts();
      setPosts(data);
    };
    fetchData();
  }, []);

  return (
    <div className="container mx-auto mt-8">
      <h1 className="text-3xl font-bold mb-6">Blog Posts</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {posts.map(post => (
          <div key={post.id} className="bg-white shadow-md rounded-lg overflow-hidden">
            <img src={post.jetpack_featured_media_url} alt={post.title.rendered} className="w-full h-48 object-cover" />
            <div className="p-4">
              <h2 className="text-xl font-bold mb-2">{post.title.rendered}</h2>
              <p className="text-gray-700">{post.excerpt.rendered.replace(/<[^>]+>/g, '')}</p>
              <Link to={`/post/${post.id}`} className="mt-4 inline-block bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600">
                Read
              </Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PostsList;
